<template>
    <div>
        <Popup v-model="popupShow" closeable close-icon-position="top-right" @close="close" style="width: 90%">
            <NavBar v-if="point.id==null" title="创建打卡点"/>
            <NavBar v-else title="修改打卡点"/>
            <Cell title="图片" required/>
            <UploadImage
                    :imageList="image"
                    style="margin-left:100px;"
                    type="SafetyImage"
                    :count="1"
                    @imageChange="imageChange"
                    edit
            />
            <Field
                    clearable
                    label="名称"
                    placeholder="请输入名称"
                    v-model="point.name"
                    required
                    :rules="[{ required: true, message: '请输入名称' }]"
            />
            <Field
                    clearable
                    label="所属单位"
                    placeholder="请选择所属单位"
                    v-model="unitName"
                    right-icon="arrow-down"
                    required
                    @click="unitPanel=true"
                    :rules="[{ required: true, message: '所属单位必填' }]"
            />
            <Field
                    clearable
                    label="备注"
                    placeholder="请输入备注"
                    v-model="point.remark"
            />
            <Field
                    clearable
                    label="地址"
                    v-model="point.address"
                    required
                    right-icon="location"
                    @click-right-icon="switchPanel('map')"
            />
            <div v-if="taskPoint.id == null">
                <pf code="SAFETY_POSITION_ADD">
                    <Button type="info" block style="width: 90% ; margin: 10px auto;" @click="submit">保存</Button>
                </pf>
            </div>
            <div v-else>
                <pf code="SAFETY_POSITION_EDIT">
                    <Button type="info" block style="width: 90% ; margin: 10px auto;" @click="submit">保存</Button>
                </pf>
            </div>
        </Popup>
        <SelectTreePopup :show="unitPanel" :defaultSelected="point.unitId?{id:point.unitId,name:point.unitName}:{}"
                         :treeData="unitTree"
                         :defaultTitle="unitName" @ok="onUnitOk" @cancel="unitPanel=false"/>
        <MapPanel :show="mapPanel" @panel="switchPanel"
                  :areaId="point.areaId" :lng="point.lng" :lat="point.lat" type="map"
        />
    </div>
</template>

<script>
    import {Cell, Popup, Form, Field, Button, NavBar} from "vant"
    import UnitPanel from "@/components/UnitPanel";
    import UploadImage from "@/components/UploadImage";
    import MapPanel from "@/components/MapPanelreport";
    import {mapGetters} from 'vuex'
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"

    export default {
        components: {SelectTreePopup,MapPanel, Cell, UploadImage, UnitPanel, Popup, Form, Field, Button, NavBar},
        props: {
            type: {type: String, default: "default"},
            show: {type: Boolean, default: false},
            taskPoint: {type: Object, required: true}
        },
        data() {
            return {
                unitPanel: false,
                popupShow: false,
                mapPanel: false,
                point: {}
            }
        },
        computed: {
            image() {
                return this.point.image ? [this.point.image] : [];
            },
            ...mapGetters({unitTree: 'global/unitTreeDisOrgans'}),
            unitName() {
                return this.point.unitName || '选择单位'
            }
        },
        created(){
        },
        mounted() {
        },
        methods: {
            onUnitOk(data){
                this.unitPanel=false
                this.point.unitId = data.id;
                this.point.unitName = data.name;
                this.point.areaId = data.areaId;
                this.point.lng = data.lng;
                this.point.lat = data.lat;
            },
            submit() {
                this.$toast.loading("正在处理中...")
                if (this.taskPoint.id == null) {
                    this.$http.tokiot.safety.point.position.create(this.point)
                        .then(res => {
                            if (res) {
                                this.$toast.success("添加成功")
                                this.popupShow = !this.popupShow
                                this.$emit("onRefresh")
                            } else {
                                this.$toast.fail(res.message)
                            }
                        })
                } else {
                    this.$http.tokiot.safety.point.position.update(this.point)
                        .then(res => {
                                if (res) {
                                    this.$toast.success("修改成功")
                                    this.popupShow = !this.popupShow
                                    this.$emit("onRefresh")
                                } else {
                                    this.$toast.fail(res.message)
                                }
                            }
                        )
                }
            },
            switchPanel(type, data) {
                switch (type) {
                    // case "unit":
                    //     if (data && data !== "unit") {
                    //         console.info('选择了单位', data)
                    //         this.point.unitId = data.id;
                    //         this.point.unitName = data.name;
                    //         this.point.areaId = data.areaId;
                    //         this.point.lng = data.lng;
                    //         this.point.lat = data.lat;
                    //     }
                    //     this.unitPanel = !this.unitPanel;
                    //     break;
                    case "map":
                        if (data && data !== "map") {
                            if (data[0] !== 0 && data[1] !== 0) {
                                let This = this;
                                new AMap.Geocoder().getAddress(data, function (status, result) {
                                    This.$set(This.point, "address", result.regeocode.formattedAddress)
                                });
                                This.$set(This.point, "lng", data[0])
                                This.$set(This.point, "lat", data[1])
                            }
                        }
                        console.info('地图', data, this.point)
                        this.mapPanel = !this.mapPanel;
                        break;
                    default:
                        break;
                }
            },
            imageChange(imageList) {
                this.point.image = imageList[0];
            },
            close() {
                this.$emit('panel', this.type,)
            },
        },
        watch: {
            'point.lng'(lng) {
                console.info('lng', lng)
            },
            'point.lat'(lat) {
                console.info('lat', lat)
            },
            'point.address'(address) {
                console.info('address', address)
            },
            show(show) {
                this.popupShow = show
            },
            taskPoint(taskPoint) {
                this.point = {...taskPoint};
            },
        }
    }
</script>

<style scoped>

</style>